var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 18,
    rx: 18,
    ry: 18,
    fill: "#4285F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5938 11.3965H11.3938C10.4863 11.3965 9.75202 12.139 9.75202 13.0465L9.74377 22.9465C9.74377 23.854 10.4863 24.5965 11.3938 24.5965H24.5938C25.5013 24.5965 26.2438 23.854 26.2438 22.9465V13.0465C26.2438 12.139 25.5013 11.3965 24.5938 11.3965ZM24.2638 14.9027L18.431 18.5492C18.167 18.7142 17.8205 18.7142 17.5565 18.5492L11.7238 14.9027C11.641 14.8563 11.5686 14.7936 11.5108 14.7183C11.4531 14.6431 11.4112 14.5569 11.3876 14.465C11.3641 14.3731 11.3595 14.2773 11.3741 14.1836C11.3887 14.0898 11.4221 14 11.4724 13.9196C11.5227 13.8391 11.5887 13.7697 11.6666 13.7156C11.7445 13.6614 11.8326 13.6236 11.9255 13.6044C12.0184 13.5853 12.1142 13.5852 12.2072 13.6041C12.3001 13.6231 12.3883 13.6607 12.4663 13.7147L17.9938 17.1715L23.5213 13.7147C23.5993 13.6607 23.6874 13.6231 23.7804 13.6041C23.8733 13.5852 23.9691 13.5853 24.0621 13.6044C24.155 13.6236 24.243 13.6614 24.3209 13.7156C24.3988 13.7697 24.4649 13.8391 24.5152 13.9196C24.5654 14 24.5989 14.0898 24.6134 14.1836C24.628 14.2773 24.6234 14.3731 24.5999 14.465C24.5764 14.5569 24.5345 14.6431 24.4767 14.7183C24.4189 14.7936 24.3465 14.8563 24.2638 14.9027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.59e34530d79b85daf0915b89424e1cb3.svg";
export { ForwardRef as ReactComponent };